/**
 * Text utility functions
 *
 * @module utils/TextUtils
 */

/**
 * Calculates the visual length of a string, correctly handling graphemes like emoji.
 * @param {string} [text] - The string to measure.
 * @returns {number} The number of graphemes in the string.
 */
export const getVisualLength = ( text ) => {
  if( !text ){
    return 0;
  }
  const segmenter = new Intl.Segmenter( 'en', { granularity: 'grapheme' } );
  return Array.from( segmenter.segment( text ) ).length;
};

